import { Select } from '@mui/material'
import { GenericTextInput } from './Fields/GenericTextInput'

const availableAssets = [
  {
    regNo: 31694,
    imageUrl: '/Views/Public/GetPDFDocument.aspx?imageId=17244',
    make: 'Mercedes-Benz',
    modelYear: 2025,
    model: 'EQA',
    variant: 'EQA 250+ Special Edition',
    engineType: 'Electric'
  },
  {
    regNo: 316888,
    imageUrl: '/Views/Public/GetPDFDocument.aspx?imageId=17211',
    make: 'BMW',
    modelYear: 2024,
    model: '3-serie',
    variant: '320i xDrive Sedan Auto',
    engineType: 'Gasoline'
  },
  {
    regNo: 31702,
    imageUrl: '/Views/Public/GetPDFDocument.aspx?imageId=17290',
    make: 'BMW',
    modelYear: 2024,
    model: 'i5',
    variant: '84kWh eDrive40 M Sport Active Edition',
    engineType: 'Electric'
  },
  {
    regNo: 316887,
    imageUrl: '/Views/Public/GetPDFDocument.aspx?imageId=17278',
    make: 'Xpeng',
    modelYear: 2023,
    model: 'G9',
    variant: 'BEV 98kWh AWD Performance',
    engineType: 'Electric'
  }
]

export function ApplicationAssetDetails({ onNext, onBack, setValue, trigger }) {
  function handleChange(id) {
    const selectedCar = availableAssets
      .map((car) => {
        console.log(car)
        if (car.regNo == id) {
          return car
        }
      })
      .filter((car) => car !== undefined)[0]

    setValue('assetDetails', {
      ...selectedCar
    })
  }

  async function handleNext() {
    const isValid = await trigger('assetDetails')
    if (!isValid) return
    onNext()
  }
  return (
    <div className="flex flex-col gap-6 min-h-[480px] justify-between">
      <div className="flex flex-col gap-10 popUp">
        <div className="flex flex-col gap-2">
          <label htmlFor="assetDetails.regNo" className="text-xs">
            Select Asset
          </label>
          <select
            onChange={(e) => handleChange(e.target.value)}
            name="assetDetails.regNo"
            id="assetDetails.regNo"
            className="bg-transparent text-gray-400 rounded-md border-2 border-primary transition-all ease-in-out h-10 px-4 text-xs "
          >
            <option value="">Select Asset</option>
            {availableAssets.map((asset) => (
              <option key={asset.regNo} value={asset.regNo}>
                {asset.make} {asset.model} {asset.variant}
              </option>
            ))}
          </select>
        </div>
        <div className="grid grid-cols-2 gap-6">
          <GenericTextInput name="assetDetails.make" label="Car Make" placeholder="Car Make" type="text" />
          <GenericTextInput name="assetDetails.model" label="Model" placeholder="Model" type="text" />
          <GenericTextInput name="assetDetails.variant" label="Variant" placeholder="Variant" type="text" />
          <GenericTextInput name="assetDetails.modelYear" label="Model Year" placeholder="Model Year" type="text" />
        </div>
      </div>
      <div className="flex w-full justify-between">
        <button
          type="button"
          onClick={() => onBack()}
          className="bg-background px-10 text-primary border-2 border-primary rounded-md hover:rounded-xl transition-all ease-in-out shadow-md p-4 flex items-center justify-center gap-4"
        >
          Back
        </button>
        <button
          type="button"
          onClick={() => handleNext()}
          className="bg-primary px-10 border-2 text-background border-primary rounded-md hover:rounded-xl transition-all ease-in-out shadow-md p-4 flex items-center justify-center gap-4"
        >
          Next
        </button>
      </div>
    </div>
  )
}
